/**
 * Created by Aleksandr on 06.05.2024
 */

Mission.TYPE_OLD_PIGGY_BANK = 65;

Mission.REGISTRATIONS.set(Mission.TYPE_OLD_PIGGY_BANK, () => ({
    available: cleverapps.config.availables.PIGGY_BANK_MISSION,
    abTest: () => !PiggyBankMissionLogic.IsNewPiggyBank(),
    needsPayments: true,
    canStart: OldPiggyBankMissionLogic.CanStart,
    name: "PiggyBank",
    view: OldPiggyBankWindow,
    startWindow: OldPiggyBankWindow,
    semaphore: Mission.SEMAPHORE_CUSTOM_PIGGY_BANK,
    duration: "2 days",
    guideWindow: {
        name: "OldPiggyBankRulesWindow",
        bundle: bundles.oldpiggybankruleswindow,
        title: "OldPiggyBankRulesWindow.title"
    },
    sideBarJson: bundles.sidebar.jsons.old_piggybank_icon_json,
    finishWindow: OldPiggyBankWindow,
    logic: OldPiggyBankMissionLogic
}));
